import Interaction from "../../../models/interactions/Interaction";
import { selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { ISequence } from "../../../models/interactions/Sequence";
import { useSelector } from "react-redux";
import { useUpdateActiveSequence } from "../useUpdateActiveSequence.hook";

export default function useUpdateSequenceInteraction() {
  const sequence = useSelector(selectSelectedElement) as ISequence;
  const { updateSequence } = useUpdateActiveSequence();

  const updateInteraction = (nodeId: string, interaction: Interaction) => {
    const copy = structuredClone(sequence);
    const node = copy.nodes.find((node) => node.id === nodeId);
    if (node) {
      node.data.interaction = interaction;
    }

    updateSequence({
      ...sequence,
      nodes: copy.nodes,
    } as ISequence);
  };

  return { updateInteraction, sequence };
}
